<template>
  <Dialog :visible="visible" class="irinox-dialog-light" :modal="true" 
              :closable="false" :dismissableMask="true" :style="{width: '500px'}" :draggable="false"
              @update:visible="updateVisible" @show="show">
    
    <template #header>
      <img src="assets/irinox/icons/arrow_back.svg" @click="updateVisible(false)" :alt="$t('common.arrow_left')"/>
      <div>{{$t('energy.editUnitCost.title')}}</div>
    </template>

    <div class="irinox-dialog-light-content layout-content">
      <div class="subtitle p-pb-2">{{$t('energy.editUnitCost.subtitle')}}</div>
      <div class="irinox-form p-pt-2">
        <div class="p-fluid p-formgrid p-grid p-pl-4 p-pr-4 p-flex-column">
              <div class="p-field p-col">
                  <label for="currency">{{$t('energy.editUnitCost.currency')}}</label>
                  <Dropdown v-model="curr" :options="currencies" optionLabel="label" optionValue="value"/>
              </div>
              <div class="p-field p-col">
                  <label for="unitCost">{{$t('energy.editUnitCost.cost')}}</label>
                  <InputNumber v-model="cost" inputId="unitCost" :minFractionDigits="2" :maxFractionDigits="2" 
                  :min="0" :placeholder="$functions.currencies()[curr]+'/kWh'"
                    :class="{'p-invalid': !cost && submitted}" :suffix="' '+$functions.currencies()[curr]+'/kWh'" />
              </div>
              <div class="p-field p-col p-d-flex p-ai-center p-jc-between" style="width: 100%;">
                  <label for="applyAll">{{$t('energy.editUnitCost.apply_all')}}</label>
                  <InputSwitch inputId="applyAll" v-model="applyAll"/>
              </div>
          </div>
      </div>
    </div>


    <template #footer>
      <!-- <Button :label="$t('energy.editUnitCost.cancel_button')" class="p-button-secondary"  @click="updateVisible(false)"/> -->
      <Button :label="$t('energy.editUnitCost.save_button')" @click="buttonClick"/>
    </template>
  </Dialog>

  <IrinoxDialogDark :visible="dialog.error" mode="error" :message="$t('energy.editUnitCost.error_dialog')"
    :life="5000" @update:visible="dialog.error = $event" />

  <IrinoxDialogDark :visible="dialog.success" 
    mode="success" 
    :message="$t('energy.editUnitCost.success_dialog')"
    :life="3000" 
    @update:visible="dialog.success = $event" />

</template>

<script>
import IrinoxDialogDark from '../IrinoxDialogDark.vue';
import ApplianceService from '../../service/ApplianceService';
import { mapGetters } from 'vuex';

export default {
    components: {
      IrinoxDialogDark,
    },
    emits: ['update:visible', 'update:unitCost'],
    props: {
      visible: Boolean,
      serialNumber: String,
      unitCost: Number,
      currency: String,
    },
    data() {
        return {
          submitted: false,
          curr: this.currency || 'EUR',
          cost: this.unitCost || null,
          applyAll: false,
          dialog: {
            error: false,
            success: false
          },
          currencies: [],
        };
    },
    computed: {
      ...mapGetters({
        personaltoken: 'userdata/personaltoken',
      }),
    },
    created() {
      this.applianceService = new ApplianceService();
    },
    methods: {
      updateVisible(value) {
        if(!value) {
          this.submitted = false;
          this.cost = null;
          this.curr = null;
        }
        this.$emit("update:visible", value);
      },
      buttonClick() {
        this.submitted = true;

        if(this.cost === null || this.cost < 0) {
          return;
        }


        if(this.applyAll) {
          this.applianceService.putApplianceAllEnergyCost(this.personaltoken, this.cost, this.curr)
            .then((data) => {
              if (data.code == "200") {
                this.dialog.success = true;
                this.$emit("update:unitCost", this.cost);
              } else {
                console.error(JSON.stringify(data));
                this.dialog.error = true;
              }
            })
            .catch(error => {
              console.error("ERROR " + error);
              this.dialog.error = true;
            })
            .finally(() => {
              this.updateVisible(false);
            });
        } else {
          this.applianceService.putApplianceEnergyCost(this.personaltoken, this.serialNumber, this.cost, this.curr)
            .then((data) => {
              if (data.code == "200") {
                this.dialog.success = true;
                this.$emit("update:unitCost", this.cost);
              } else {
                console.error(JSON.stringify(data));
                this.dialog.error = true;
              }
            })
            .catch(error => {
              console.error("ERROR " + error);
              this.dialog.error = true;
            })
            .finally(() => {
              this.updateVisible(false);
            });
        }

        // setTimeout(() => {
        //   this.updateVisible(true);
        // }, 5200);

      },
      show() {
        this.cost = this.unitCost || null;
        this.curr = this.currency || 'EUR';
        this.currencies = [];
        let c = Object.keys(this.$functions.currencies());
        for(let i=0; i<c.length; i++) {
          this.currencies.push({label: this.$t('currencies.'+c[i]) + ' ('+c[i]+')', value: c[i]});
        }
      },
    }
}
</script>

<style>

</style>